import { render, staticRenderFns } from "./SalesPersonOrdersPerSegmentPopup.vue?vue&type=template&id=40a56e71"
import script from "./SalesPersonOrdersPerSegmentPopup.vue?vue&type=script&lang=js"
export * from "./SalesPersonOrdersPerSegmentPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports